import eventBus from "@/eventBus"
import { EVENT_BUS_EVENTS } from "@/constants/EVENT_BUS_EVENTS"

const catchForbiddenError = () => {
  // TODO: Implement 403 error screen
  eventBus.$emit(EVENT_BUS_EVENTS.REQUEST_ERROR_CAPTURED, 404)
}

export default catchForbiddenError
